import React from 'react';

import { useAuth } from '@clerk/clerk-react';
import { Navigate, Outlet } from 'react-router-dom';

import { TFLoadingOverlay } from '@tf/ui';

interface Props {
	startPagePath: string;
}

export const NonAuthenticatedRoutesGuard: React.FC<Props> = ({ startPagePath }) => {
	const { isSignedIn } = useAuth();

	if (isSignedIn === undefined) {
		return <TFLoadingOverlay />;
	}

	if (isSignedIn) {
		return <Navigate to={startPagePath} />;
	}

	return <Outlet />;
};
